import { graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import React, { useContext, useEffect, useState } from 'react';
import '../../language-tabs.css';
import {
  Container,
  Image,
  Post,
  PostComments,
  SEO,
  TableOfContents,
  Tags,
} from '../components';
import AppContext from '../context';
import {
  H1,
  HR,
  P,
  PostImageWrapper,
  PostLayout,
  SideBarWrapper,
} from '../elements';

const SinglePost = ({ data }) => {
  const image = data.mdx.frontmatter.featureImage.childImageSharp?.fixed;
  const { extension, publicURL } = data.mdx.frontmatter.featureImage;
  const { excerpt, date, title, author, readTime, tags } = data.mdx.frontmatter;
  const { items } = data.mdx.tableOfContents;

  const { dark } = useContext(AppContext);
  const [theme, setTheme] = useState(dark ? 'dark-blue' : 'github-light');

  useEffect(() => {
    setTheme(dark ? 'dark-blue' : 'github-light');
  }, [dark]);

  return (
    <Container>
      <SEO title={data.mdx.frontmatter.title} description={excerpt} />
      <Image fixed={image} extension={extension} publicURL={publicURL} />
      <PostLayout>
        <SideBarWrapper />
        <PostImageWrapper>
          <Post>
            <H1 margin='0 0 0.5rem 0'>{title}</H1>
            <P margin='1rem 0'>{excerpt}</P>
            <div>
              <p className='author_name' style={{ padding: 0, margin: 0 }}>
                {author}
              </p>

              <p
                style={{
                  color: 'rgb(139, 139, 139)',
                  fontSize: '14px',
                }}
              >
                <span style={{ marginRight: '0.25rem' }}>{date}</span> &bull;{' '}
                <span style={{ marginLeft: '0.25rem' }}>{readTime}</span>
              </p>
              <Tags tags={tags} />
            </div>
            <HR />
            <MDXRenderer>{data.mdx.body}</MDXRenderer>
          </Post>
        </PostImageWrapper>

        <SideBarWrapper>
          {items && <TableOfContents items={items} />}
        </SideBarWrapper>
      </PostLayout>
      <PostComments title={title} theme={theme} />
    </Container>
  );
};

export default SinglePost;

export const pageQuery = graphql`
  query SinglePostQuery($id: String!) {
    mdx(id: { eq: $id }) {
      body
      tableOfContents
      frontmatter {
        date(formatString: "DD  MMMM  YYYY")
        title
        excerpt
        readTime
        author
        slug
        tags
        featureImage {
          childImageSharp {
            fixed {
              ...GatsbyImageSharpFixed
            }
          }
          extension
          publicURL
        }
      }
    }
  }
`;
